import React, { useState } from 'react';
import {
  PeopleOutlined,
  AssessmentOutlined,
  LayersOutlined,
  LogoutOutlined,
  DashboardOutlined,
  Menu,
  Close,
  PersonOutlined,
} from '@mui/icons-material';
import useAuth from '../../../hooks/useAuth';
import ProfileScreen from '../../../screens/Profilescreen';
import logoSidebar from '../../../assets/images/logo-sidebar.png';
import './Sidebar.css';

const Sidebar = ({ activeSection, setActiveSection }) => {
  const { logout } = useAuth();
  const [collapsed, setCollapsed]     = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [mobileOpen, setMobileOpen]   = useState(false);

  const menuSections = [
    {
      section: 'GESTION',
      items: [
        { id: 'users', label: 'Utilisateurs', icon: <PeopleOutlined /> },
      ],
    },
    {
      section: 'SUPERVISION',
      items: [
        { id: 'userLogs',   label: 'Logs Utilisateurs', icon: <AssessmentOutlined /> },
        { id: 'secufireActionLogs',  label: 'Logs SecuFire Action',       icon: <LayersOutlined /> },
      ],
    },
  ];

  // ✅ Empêche le rechargement quand on clique sur l'onglet déjà actif
  const handleSetActive = (id) => {
    if (id !== activeSection) setActiveSection(id);
    setMobileOpen(false);
  };

  return (
    <>
      {/* Bouton hamburger — visible uniquement en mobile */}
      <button
        className={`sidebar-mobile-toggle ${mobileOpen ? 'sidebar-mobile-toggle--open' : ''}`}
        onClick={() => setMobileOpen((v) => !v)}
        aria-label={mobileOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      >
        {mobileOpen ? <Close /> : <Menu />}
      </button>

      {/* Overlay — visible uniquement quand le menu mobile est ouvert */}
      {mobileOpen && (
        <div className="sidebar-mobile-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>

        {/* Header */}
        <div className="sidebar-header">
          <img
            src={logoSidebar}
            alt="SecuFire Action"
            className={collapsed ? 'sidebar-logo-mini' : 'sidebar-logo'}
          />
        </div>

        {/* Navigation */}
        <nav className="sidebar-menu">
          <button
            className={`menu-item ${activeSection === 'dashboard' ? 'active' : ''}`}
            onClick={() => handleSetActive('dashboard')}
            title={collapsed ? 'Dashboard' : ''}
          >
            <div className="menu-icon"><DashboardOutlined /></div>
            {!collapsed && <span className="menu-label">Dashboard</span>}
          </button>

          {menuSections.map((section) => (
            <div key={section.section} className="menu-section">
              {!collapsed && <div className="section-label">{section.section}</div>}
              {section.items.map((item) => (
                <button
                  key={item.id}
                  className={`menu-item ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => handleSetActive(item.id)}
                  title={collapsed ? item.label : ''}
                >
                  <div className="menu-icon">{item.icon}</div>
                  {!collapsed && <span className="menu-label">{item.label}</span>}
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">

          {/* Bouton profil */}
          <button
            className="menu-item profile-item"
            onClick={() => setShowProfile(true)}
            title={collapsed ? 'Mon profil' : ''}
          >
            <div className="menu-icon"><PersonOutlined /></div>
            {!collapsed && <span className="menu-label">Mon profil</span>}
          </button>

          {/* Déconnexion */}
          <button
            className="menu-item logout-item"
            onClick={logout}
            title={collapsed ? 'Déconnexion' : ''}
          >
            <div className="menu-icon"><LogoutOutlined /></div>
            {!collapsed && <span className="menu-label">Déconnexion</span>}
          </button>
        </div>
      </aside>

      {/* Panel profil */}
      {showProfile && <ProfileScreen onClose={() => setShowProfile(false)} />}
    </>
  );
};

export default Sidebar;